// extracted by mini-css-extract-plugin
export default {"mn-popover-card":"index_mn-popover-card__wmuJQ"};